import { useContext } from "react";
import { PspContext } from "@/config/contexts";
import { useImpersonation } from "@/config/hooks";
import { translate } from "@/config/translator";
import { faRightFromBracket } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";

export function ImpersonationBanner() {
  const { lang, user } = useContext(PspContext);
  const { isImpersonating, returnToAdmin } = useImpersonation();

  if (!isImpersonating || !user) return null;

  return (
    <div
      className={clsx(
        "flex",
        "flex-row",
        "flex-wrap",
        "items-center",
        "justify-center",
        "gap-3",
        "bg-amber-400",
        "text-black",
        "px-4",
        "py-2",
        "text-sm",
        "font-semibold",
        "text-center",
      )}
    >
      <span>
        {translate("viewingAsUser", lang, { "{userName}": user.name })}
      </span>
      <button
        onClick={returnToAdmin}
        className="flex flex-row items-center gap-2 underline underline-offset-2 cursor-pointer"
      >
        <FontAwesomeIcon icon={faRightFromBracket} />
        {translate("returnToAdmin", lang)}
      </button>
    </div>
  );
}
